import React from 'react';
import { motion } from 'framer-motion';
import { useChartData } from '../hooks/useChartData';
import type { SiteTimeSeries } from '../types';

interface ResponseTimeChartProps {
    timeSeries: SiteTimeSeries[];
    isLoading: boolean;
}

export const ResponseTimeChart: React.FC<ResponseTimeChartProps> = ({ 
    timeSeries, 
    isLoading 
}) => {
    const { labels, datasets, minMax } = useChartData(timeSeries, 'responseTime');

    if (isLoading || datasets.length === 0) {
        return (
            <div className="mx-[18px] h-[180px] bg-[var(--bg-elevated)] border border-[var(--border)] rounded-xl animate-pulse" />
        );
    }

    return (
        <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            className="mx-[18px] bg-[var(--bg-elevated)] border border-[var(--border)] rounded-xl p-4"
        >
            <div className="flex items-center justify-between mb-4">
                <h3 className="text-[13px] font-medium text-[var(--text)]">Время ответа</h3>
                <span className="text-[11px] text-[var(--text-muted)]">миллисекунды</span>
            </div>

            <div className="h-[140px] flex items-end gap-1">
                {datasets[0]?.data.map((val, i) => {
                    const height = ((val - minMax.min) / (minMax.max - minMax.min)) * 100;
                    const isHigh = val > 800;
                    
                    return (
                        <motion.div
                            key={i}
                            initial={{ height: 0 }}
                            animate={{ height: `${Math.max(height, 5)}%` }}
                            transition={{ delay: i * 0.01 }}
                            className={`flex-1 rounded-t-sm min-h-[4px] relative group ${
                                isHigh ? 'bg-[var(--status-warn)]' : 'bg-[var(--brand)]'
                            }`}
                            style={{ opacity: 0.3 + (i / datasets[0].data.length) * 0.7 }}
                        >
                            <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-1 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
                                <span className="text-[9px] text-[var(--text-muted)] whitespace-nowrap">
                                    {Math.round(val)}мс
                                </span>
                            </div>
                        </motion.div>
                    );
                })}
            </div>
            
            <div className="flex justify-between mt-2 text-[10px] text-[var(--text-muted)]">
                <span>{labels[0]?.replace('\n', ' ')}</span>
                <span>{labels[labels.length - 1]?.replace('\n', ' ')}</span>
            </div>
        </motion.div>
    );
};